import { render, staticRenderFns } from "./TaskTitle.vue?vue&type=template&id=77ff7feb&scoped=true&"
import script from "./TaskTitle.vue?vue&type=script&lang=ts&"
export * from "./TaskTitle.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTitle.vue?vue&type=style&index=0&id=77ff7feb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff7feb",
  null
  
)

export default component.exports